import React, { FC } from 'react';

import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import {
  PaymentIcon,
  PaymentType,
} from 'react-svg-credit-card-payment-icons/dist/index';
import { pharmacyBillingSelector } from '@pharmaplan/common';

import { useAppSelector } from '../../../../../../../hooks/useAppSelector';
import strings from '../../../../../../../localization';

import styles from '../styles';

interface ISavedCard {
  showCardType?:boolean;
  customTitle?:string
}

const SavedCard:FC<ISavedCard> = ({ showCardType = true, customTitle }) => {
  const savedDetails = useAppSelector(pharmacyBillingSelector);
  const { cardType, creditCardLast4, brand } = savedDetails ?? {};
  const mask4Digits = 'x'.repeat(4);
  const firstTwelve = `${mask4Digits} ${mask4Digits} ${mask4Digits} `;

  return (
    <>
      <Typography sx={styles.title}>{customTitle ?? strings.cardDetails}</Typography>
      <Box sx={styles.cardDigitContainer}>
        <PaymentIcon format="flat" type={(brand ?? '') as PaymentType} />
        <Box sx={styles.cardDetailContainer}>
          {showCardType && (
          <Typography sx={styles.cardType}>
            {strings.formatString(strings.cardType, cardType ?? '')}
          </Typography>
          )}
          <Typography sx={styles.lastDigits}>
            {firstTwelve + creditCardLast4}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default SavedCard;
